// v2.0
(function() {
    var elems = document.querySelectorAll('.showhide__link');
    if (!elems.length) return;

    function getAction(linkElem) {
        return linkElem.dataset.showhideAction ? linkElem.dataset.showhideAction : 'toggle' ;
    }

    function getClassName(linkElem) {
        return linkElem.dataset.showhideClass ? linkElem.dataset.showhideClass : 'hidden' ;
    }

    function getTargetElem(linkElem) {
        return document.querySelector(linkElem.dataset.showhideTarget ? linkElem.dataset.showhideTarget : linkElem.getAttribute('href')) ;
    }

    function setTargetElemState(linkElem) {
        var targetElem = getTargetElem(linkElem);
        if (!targetElem) return;
        var action = getAction(linkElem);
        var className = getClassName(linkElem);
        if ('show' == action) targetElem.classList.remove(className);
        else if ('hide' == action) targetElem.classList.add(className);
        else targetElem.classList.toggle(className);
    }

    function setLinkTextState(linkElem, action, className) {
        var textShowElem = linkElem.querySelector('.showhide__text--show');
        if (!textShowElem) return;
        var textHideElem = linkElem.querySelector('.showhide__text--hide');
        if (!textHideElem) return;
        if ('show' == action) {
            textShowElem.classList.add(className);
            textHideElem.classList.remove(className);
        } else if ('hide' == action) {
            textShowElem.classList.remove(className);
            textHideElem.classList.add(className);
        } else {
            textShowElem.classList.toggle(className);
            textHideElem.classList.toggle(className);
        }
    }

    // options: data-showhide-target, data-showhide-class, data-showhide-action [toggle|show|hide]
    // example: <a class="showhide__link" href="#transcript"><span class="showhide__text showhide__text--show">Show Transcript</span><span class="showhide__text showhide__text--hide hidden">Hide Transcript</span></a>
    document.addEventListener('click', function(e) {
        var linkElem = e.target.closest('.showhide__link');
        if (!linkElem) return;
        e.preventDefault();
        setTargetElemState(linkElem);
        // set link text state for related links
        var targetElem = getTargetElem(linkElem);
        var action = getAction(linkElem);
        var className = getClassName(linkElem);
        elems.forEach(function(elem2){
            var targetElem2 = getTargetElem(elem2);
            if (targetElem == targetElem2) setLinkTextState(elem2, action, className);
        });
    });
})();
